import { render, staticRenderFns } from "./ImportChangeListItem.vue?vue&type=template&id=0907c69e"
import script from "./ImportChangeListItem.vue?vue&type=script&lang=js"
export * from "./ImportChangeListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports